/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import PasswordInput from './Password';
import $ from 'jquery';
import { connect } from 'react-redux';
import { passwordRegex } from '../../../assets/constants/strings';
import AuthLoader from '../../Loader/Auth';
import { updatePassword, clearUpdatePass } from '../../../store/User/userActions';

const ChangePassword = ({ loading, result, updatePassword, clearUpdatePass }) => {

  const [old, setOld] = useState('');
  const [newPass, setNewPass] = useState('');
  const [confirm, setConfirm] = useState('');

  const [errorMessage, setErrorMessage] = useState(null);

  const [userSubmitted, setUserSubmitted] = useState(false);

  const hideModal = () => $('#passwordModal').modal('hide');

  // cleanup on dismiss
  useEffect(() => {
    $('#passwordModal').on('hide.bs.modal', () => {
      setOld('');
      setNewPass('');
      setConfirm('');
    });
  }, []);

  /**
   * 
   * @param {React.FormEvent<HTMLFormElement>} e 
   * @returns 
   */
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!loading && userSubmitted && result && result.success === true) {
      clearUpdatePass();
      hideModal();
      return;
    }

    // if (loading || (userSubmitted && !error)) return;

    if (!passwordRegex(old)) {
      // || !passwordRegex(newPass) || newPass !== confirm) {
      setErrorMessage('Current Password format invalid.')
      return;
    }
    if (!passwordRegex(newPass)) {
      setErrorMessage('New Password format invalid.')
      return;
    }
    if (newPass === old) {
      setErrorMessage('Current and New passwords are the same.')
      return;
    }
    if (newPass !== confirm) {
      setErrorMessage('New and Confirm passwords do not match.')
      return;
    }

    updatePassword({
      oldPassword: old,
      newPassword: newPass,
      reNewPassword: confirm
    });
  };

  useEffect(() => {
    // if card is showing and load state is triggered
    if (loading === true &&
      document.getElementById('passwordModal').className.match('show')) {
      setUserSubmitted(true);
    }
  }, [loading]);

  useEffect(() => {
    setErrorMessage(null);
  }, [old, newPass, confirm]);

  return (
    <div
      className="modal card-modal"
      id="passwordModal"
      role="dialog"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div className="modal-dialog modal-dialog-centered modal-md">
        <div className="modal-content">
          <div className="modal-header">
            <h3 className="modal-title">Change Password</h3>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit} autoComplete="off">

              <PasswordInput
                id="Password"
                label="Enter Current Password"
                password={old}
                setPassword={(e) => setOld(e.target.value)}
                disabled={loading || (userSubmitted && result && result.success === true)}
              />

              <PasswordInput
                id="NewPassword"
                label="Enter New Password"
                password={newPass}
                setPassword={(e) => setNewPass(e.target.value)}
                isInvalid={newPass.length > 0 && newPass === old}
                disabled={loading || (userSubmitted && result && result.success === true)}
              />
              {!passwordRegex(newPass) && newPass.length > 0 && (
                <span style={{ color: '#dc3545' }}>
                  <b>
                    Your password does not meet the security criteria outlined
                    below. Please review and create a new password.
                  </b>
                </span>
              )}

              <PasswordInput
                id="ConfirmPassword"
                label="Confirm New Password"
                password={confirm}
                setPassword={(e) => setConfirm(e.target.value)}
                isInvalid={confirm.length > 0 && newPass !== confirm}
                disabled={loading || (userSubmitted && result && result.success === true)}
              />
              {newPass !== confirm &&
                newPass.length > 0 &&
                confirm.length > 0 && (
                  <span style={{ color: '#dc3545' }}>
                    <b>Password does not match.</b>
                  </span>
                )}

              <div className="text-center my-3">
                <b>
                  Passwords must contain at least 8 characters including 1 Upper
                  case character, 1 digit and 1 special character.
                </b>
              </div>

              {errorMessage && !loading && (
                <label className="text-danger my-2">{errorMessage}</label>
              )}

              {!errorMessage && !loading && result ? (
                result.success === false ? (
                  <label className="text-danger my-2">{result.reason}</label>
                ) : (
                  <label className="text-success my-2">Password Updated!</label>
                )
              ) : null}

              <div className="d-flex justify-content-between">
                <button
                  className="my-account-btn secondary"
                  onClick={hideModal}
                  type="reset"
                  data-dismiss="modal"
                  disabled={loading || (userSubmitted && !loading)}
                >
                  Cancel
                </button>
                <button
                  className="my-account-btn"
                  type="submit"
                >
                  {userSubmitted && !loading && result && result.success === true ? 'Done' : 'Save'}
                  {loading && <AuthLoader />}
                </button>
              </div>

            </form>
          </div>
        </div>
      </div >
    </div >
  );
};

const mapStateToProps = (state) => ({
  loading: state.user.loading,
  result: state.user.changePassword,
});

const mapDispatchToProps = { updatePassword, clearUpdatePass };

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);
